'use strict';

const SELECTOR = '.donation-panel';

export function init() {
    const element = document.querySelectorAll(SELECTOR);

    if (!element.length) {
        return false;
    }

    document.addEventListener('click', function(event) {
        if (!event.target.classList.contains('donation-panel__other-button')) {
            return;
        }

        document.querySelector('.donation-panel__specific-amount').classList.add('hidden');
        document.querySelector('.donation-panel__other-amount').classList.remove('hidden');
    },false);

    document.addEventListener('submit', function(event) {
        if (!event.target.classList.contains('donation-panel__form')) {
            return;
        }

        event.preventDefault();

        const specificAmountField = event.target.querySelector('.donation-panel__specific-amount:not(.hidden) input[name="specific-amount"]:checked');
        const otherAmountField = event.target.querySelector('.donation-panel__other-amount:not(.hidden) input[name="other-amount"]');

        let donationAmount = null;

        if (specificAmountField) {
            donationAmount = specificAmountField.value;
        } else if (otherAmountField) {
            donationAmount = otherAmountField.value;
        }

        if (!donationAmount) {
            alert('Please select/specify a donation amount');
        } else {
            const newLocation = event.target.dataset.action.replace('{amount}', donationAmount);
            document.location = newLocation;
            // console.log(newLocation);
        }
    });
}
